import React from 'react';
import { Link } from 'react-router-dom';
import { Video, MessageSquare, Users, Play } from 'lucide-react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';

const HomePage: React.FC = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-12 md:pt-32 md:pb-24 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/40 to-black/90 z-0"></div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-6xl font-bold mb-6 animate-fade-in">
              Transmita suas ideias para o mundo
            </h1>
            <p className="text-xl text-gray-300 mb-8 animate-slide-up">
              Plataforma simples e intuitiva para suas transmissões ao vivo,
              gravações e compartilhamento de conteúdo.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/live">
                <Button size="lg" className="w-full sm:w-auto">
                  <Play className="mr-2 h-5 w-5" /> Comece a transmitir
                </Button>
              </Link>
              <Button variant="outline" size="lg" className="w-full sm:w-auto">
                Saiba mais
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-black/80">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12">
            Recursos principais
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-secondary/30 p-6 rounded-lg transition-transform hover:translate-y-[-5px]">
              <Video className="h-12 w-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-3">Transmissão em Tempo Real</h3>
              <p className="text-gray-300">
                Inicie uma transmissão ao vivo em segundos. Compartilhe momentos especiais com seu público.
              </p>
            </div>
            
            <div className="bg-secondary/30 p-6 rounded-lg transition-transform hover:translate-y-[-5px]">
              <MessageSquare className="h-12 w-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-3">Interação com Espectadores</h3>
              <p className="text-gray-300">
                Conecte-se com seu público através de comentários e reações em tempo real.
              </p>
            </div>
            
            <div className="bg-secondary/30 p-6 rounded-lg transition-transform hover:translate-y-[-5px]">
              <Users className="h-12 w-12 text-primary mb-4" />
              <h3 className="text-xl font-semibold mb-3">Gravação e Compartilhamento</h3>
              <p className="text-gray-300">
                Capture vídeos e fotos facilmente. Compartilhe seu conteúdo em suas redes sociais.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-gray-900 to-black">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Pronto para começar sua transmissão?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            Não perca mais tempo. Comece agora a transmitir seu conteúdo para o mundo todo.
          </p>
          <Link to="/live">
            <Button size="lg">
              Iniciar transmissão
            </Button>
          </Link>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default HomePage;